import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { DispatchNoteBus } from "./DispatchNoteBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";

export class v_DispatchNoteBus extends BaseBus
{
    constructor(busObj: v_DispatchNoteBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updatedt = DateFunctions.getDate(this.updatedt);
    }
    CID(): any {
        return this.dispatchNotesId;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    setId(id: any) {
        this.dispatchNotesId = id;
    }
    setFromBusobj(data: DispatchNoteBus) {
        this.initialize(data);
        this.dispatchNotes = data.dispatchNotes1;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.dispatchNotesPersonId = personId;
        this.visibleToCustomer = false;
        this.highlight = false;
        this.techNote = false;
        this.isWarning = false;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updatedt = date;
        this.updateUserId = userId;
        if (!CommonFunctions.hasGuidValue(this.dispatchNotesPersonId)) {
            this.dispatchNotesPersonId = personId;
        }
    }
  dispatchNotesId: any;
  dispatchNotes: string;
  visibleToCustomer: boolean;
  personName: string;
  highlight: boolean;
  isWarning: boolean;
  techNote: boolean;
  updateUserId: any;
  updatedt: Date;
  insertUserId: any;
  insertDt: Date;
  dispatchId: any;
    dispatchNotesPersonId: any;
    hideLogBook: any;
  //assignedPersonId: any;
}
